import { NgModule ,APP_INITIALIZER} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DataTablesModule } from 'angular-datatables';
import { NgxSpinnerModule } from "ngx-spinner";
import { AuthenticationService } from './_services';
// import { fakeBackendProvider } from './_helpers';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { appRoutingModule } from './app.routing';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { BasicAuthInterceptor, ErrorInterceptor } from './_helpers';
// import { appInitializerww } from './_helpers/app.initializer';
import { HomeComponent } from './home';
import { LoginComponent } from './login';
import { StudentComponent } from './student/student.component';
import { VerifierComponent } from './verifier/verifier.component';
import { VerifierSupervisorComponent } from './verifier-supervisor/verifier-supervisor.component';
import { AssociateComponent } from './associate/associate.component';
import { AssociateSupervisorComponent } from './associate-supervisor/associate-supervisor.component';
import { SuperAdminComponent } from './super-admin/super-admin.component';
import { UniversityComponent } from './university/university.component';
import { RegisterStudentComponent } from './pages/register-student/register-student.component';
import { RegisterEmployerComponent } from './pages/register-employer/register-employer.component';
import { RecaptchaModule, RecaptchaFormsModule } from "ng-recaptcha";
import { NavComponent } from './Components/nav/nav.component';
import { SideFiltersComponent } from './Components/side-filters/side-filters.component';
import { VerifyDocumentComponent } from './student/verify-document/verify-document.component';
import { DocumentVerificationComponent } from './pages/document-verification/document-verification.component';
import { VerificationListComponent } from './student/verification-list/verification-list.component';
import { VerificationListDisputeComponent } from './student/verification-list-dispute/verification-list-dispute.component';
import { DocumentVerificationListComponent } from './verifier/document-verification-list/document-verification-list.component';
import { VerifierDocListComponent } from './verifier-supervisor/verifier-doc-list/verifier-doc-list.component';
import { UniversityVerificationListComponent } from './university/university-verification-list/university-verification-list.component';
import { EmployerComponent } from './employer/employer.component';
import { EmployerVerificationListComponent } from './employer/employer-verification-list/employer-verification-list.component';
import { EmployerVerificationListDisputeComponent } from './employer/employer-verification-list-dispute/employer-verification-list-dispute.component';
import { EmployerVerifyDocumentComponent } from './employer/employer-verify-document/employer-verify-document.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { VerificationFormComponent } from './verification-form/verification-form.component';
import { VerifierDisputeListComponent } from './verifier-supervisor/verifier-dispute-list/verifier-dispute-list.component';
import { AdminDisputeListComponent } from './super-admin/admin-dispute-list/admin-dispute-list.component';
import { AdminOfflineRequestComponent } from './super-admin/admin-offline-request/admin-offline-request.component';
import { VerifierOfflineRequestComponent } from './verifier-supervisor/verifier-offline-request/verifier-offline-request.component';
import { LogService } from '../app/_shared/log.service';
import { LogTestComponent } from '../app/_shared/log-test.component';
 import { FormsModule } from '@angular/forms';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { DocumentMasterComponent } from './super-admin/masters/document-master/document-master.component';
import { DocumentMasterAddComponent } from './super-admin/masters/document-master-add/document-master-add.component';
import { StreamMasterComponent } from './super-admin/masters/stream-master/stream-master.component';
import { StreamMasterAddComponent } from './super-admin/masters/stream-master-add/stream-master-add.component';
import { StreamMasterEditComponent } from './super-admin/masters/stream-master-edit/stream-master-edit.component';
import { DocumentMasterEditComponent } from './super-admin/masters/document-master-edit/document-master-edit.component';
import { PriceMasterComponent } from './super-admin/masters/price-master/price-master.component';
import { PriceMasterAddComponent } from './super-admin/masters/price-master-add/price-master-add.component';
import { PriceMasterEditComponent } from './super-admin/masters/price-master-edit/price-master-edit.component';
import { CollegeMasterComponent } from './super-admin/masters/college-master/college-master.component';
import { EmailVerificationPageComponent } from './pages/email-verification-page/email-verification-page.component';
import { CollegeMasterAddComponent } from './super-admin/masters/college-master-add/college-master-add.component';
import { CollegeMasterEditComponent } from './super-admin/masters/college-master-edit/college-master-edit.component';
import { UserMasterComponent } from './super-admin/masters/user-master/user-master.component';
import { UserMasterAddComponent } from './super-admin/masters/user-master-add/user-master-add.component';
import { UserMasterEditComponent } from './super-admin/masters/user-master-edit/user-master-edit.component';
import { DatePipe } from '@angular/common';;
import { LoginnewComponent } from './loginnew/loginnew.component';
import { UploadedDocListComponent } from './associate/uploaded-doc-list/uploaded-doc-list.component';
import { AssociateAddRecordComponent } from './associate/associate-add-record/associate-add-record.component';
import { PaymentSuccessfulPageComponent } from './pages/payment-successful-page/payment-successful-page.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TwoDigitDecimaNumberDirective } from './super-admin/masters/two-digit-decima-number.directive';
import { NgImageFullscreenViewModule } from 'ng-image-fullscreen-view';
import { DocUploadListComponent } from './associate-supervisor/doc-upload-list/doc-upload-list.component';
import { EditDocUploadListComponent } from './associate-supervisor/edit-doc-upload-list/edit-doc-upload-list.component';
import { FooterComponent } from './Components/footer/footer.component'
import { PieChartComponent } from './pie-chart.component';
import { PieChartTop10Component } from './super-admin/admin-dashboard/pie-chart-top10.component';
import { PieChartRequestRatioComponent } from './super-admin/admin-dashboard/pie-chart-requestratio.component';
import { PieChartYearRevenueComponent } from './super-admin/admin-dashboard/pie-chart-yearrevenue.component';
import { PieChartDisputeRatioComponent } from './super-admin/admin-dashboard/pie-chart-disputeratio.component';
import { BarChartMonthlyComponent } from './super-admin/admin-dashboard/bar-chart-monthly.component';
import { BarChartDailyComponent } from './super-admin/admin-dashboard/bar-chart-daily.component';
import { AdminDashboardComponent } from './super-admin/admin-dashboard/admin-dashboard.component';
import { BranchMasterComponent } from './super-admin/masters/branch-master/branch-master.component';
import { BranchMasterAddComponent } from './super-admin/masters/branch-master-add/branch-master-add.component';
import { BranchMasterEditComponent } from './super-admin/masters/branch-master-edit/branch-master-edit.component';
import { SemesterMasterComponent } from './super-admin/masters/semester-master/semester-master.component';
import { SemesterMasterAddComponent } from './super-admin/masters/semester-master-add/semester-master-add.component';
import { SemesterMasterEditComponent } from './super-admin/masters/semester-master-edit/semester-master-edit.component';;
import { SuperverifierDashboardComponent } from './verifier-supervisor/superverifier-dashboard/superverifier-dashboard.component';
import { CommonMenuComponent } from './Components/common-menu/common-menu.component';
import { PassingYearMasterComponent } from './super-admin/masters/passing-year-master/passing-year-master.component';
import { PassingYearMasterAddComponent } from './super-admin/masters/passing-year-master-add/passing-year-master-add.component';
import { PassingYearMasterEditComponent } from './super-admin/masters/passing-year-master-edit/passing-year-master-edit.component';
import {RecordEntryComponent } from './associate/record-entry/record-entry.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { FaqComponent } from './faq/faq.component';
import { RefundPolicyComponent } from './refund-policy/refund-policy.component';
import { MagnifyComponent } from './magnify/magnify.component';;
import { MisReportComponent } from './reports/mis-report/mis-report.component'
;
import { SideDateFilterComponent } from './Components/side-date-filter/side-date-filter.component'
;
//import { VerifyDocumentEditComponent } from './student/verify-document-edit/verify-document-edit.component'
;
import { VerifyEditDocumentComponent } from './student/verify-edit-document/verify-edit-document.component';


import { EmployerVerifyDocumentEditComponent } from './employer/employer-verify-document-edit/employer-verify-document-edit.component'
;
import { UniversityDashboardComponent } from './university/university-dashboard/university-dashboard.component'
;
import { VerifierRejectedRequestComponent } from './verifier/verifier-rejected-request/verifier-rejected-request.component'

@NgModule({
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        HttpClientModule,
        appRoutingModule,
        RecaptchaModule,
        DataTablesModule,
        NgbModule,
        FormsModule,
        NgxSpinnerModule  ,
        BrowserAnimationsModule,
        PdfViewerModule,
        NgImageFullscreenViewModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule
    ],
    declarations: [
        AppComponent,
        HomeComponent,
        LoginComponent,
        StudentComponent,
        VerifierComponent,
        VerifierSupervisorComponent,
        AssociateComponent,
        AssociateSupervisorComponent,
        SuperAdminComponent,
        UniversityComponent,
        RegisterStudentComponent,
        RegisterEmployerComponent,
        NavComponent,
        SideFiltersComponent,
        VerifyDocumentComponent,
        DocumentVerificationComponent,
        VerificationListComponent,
        VerificationListDisputeComponent,
        DocumentVerificationListComponent,
        VerifierDocListComponent,
        UniversityVerificationListComponent,
        EmployerComponent,
        EmployerVerificationListComponent,
        EmployerVerificationListDisputeComponent,
        EmployerVerifyDocumentComponent,
        ResetPasswordComponent,
        VerificationFormComponent,
        VerifierDisputeListComponent,
        AdminDisputeListComponent,
        AdminOfflineRequestComponent,
        VerifierOfflineRequestComponent,
        LogTestComponent,
        PageNotFoundComponent,
        DocumentMasterComponent,
        DocumentMasterAddComponent ,
        StreamMasterComponent,
        StreamMasterAddComponent,
        StreamMasterEditComponent,
        DocumentMasterEditComponent,
        PriceMasterComponent,
        PriceMasterAddComponent,
        PriceMasterEditComponent,
        CollegeMasterComponent,
        EmailVerificationPageComponent,
        CollegeMasterAddComponent,
        CollegeMasterEditComponent,
        UserMasterComponent,
        UserMasterAddComponent,
        UserMasterEditComponent,
        LoginnewComponent,
        UploadedDocListComponent,
        AssociateAddRecordComponent,
        TwoDigitDecimaNumberDirective,
        DocUploadListComponent,
        EditDocUploadListComponent,
        PaymentSuccessfulPageComponent,
        FooterComponent,
        PieChartComponent,
        PieChartTop10Component,
        PieChartRequestRatioComponent,
        PieChartYearRevenueComponent,
        PieChartDisputeRatioComponent,
        BarChartMonthlyComponent,
        BarChartDailyComponent,
        AdminDashboardComponent,
        BranchMasterComponent,
        BranchMasterAddComponent ,
        BranchMasterEditComponent ,
        SemesterMasterComponent,
        SemesterMasterAddComponent,
        SemesterMasterEditComponent,
        SuperverifierDashboardComponent,
        CommonMenuComponent,
        PassingYearMasterComponent,
        PassingYearMasterAddComponent ,
        PassingYearMasterEditComponent,
        RecordEntryComponent
,
        LandingPageComponent
,
        FaqComponent ,
        RefundPolicyComponent ,
        MagnifyComponent ,
        MisReportComponent ,
        SideDateFilterComponent ,
      //  VerifyDocumentEditComponent ,
        VerifyEditDocumentComponent   ,
        EmployerVerifyDocumentEditComponent ,
        UniversityDashboardComponent ,
        VerifierRejectedRequestComponent ,
],

    providers: [
        LogService,DatePipe,MatDatepickerModule,MatNativeDateModule,MatInputModule,
        // { provide: APP_INITIALIZER, useFactory: appInitializerww, multi: true, deps: [AuthenticationService] },
        { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

        // provider used to create fake backend
        //fakeBackendProvider
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }